module.exports = __webpack_public_path__ + "img/mazda-seo-content-collapsible-01.fab2065c.png";